import { gql } from '@apollo/client';

export const QL_SECRETS_SUMMARY = gql`
  query secretsSummary($args: SecretsSummaryInput!) {
    secretsSummary(args: $args) {
      total
      high
      medium
      low
      invalid
    }
  }
`;

export const QL_SECRET_TYPES_AND_COUNT = gql`
  query secretTypesAndCount($args: SecretTypesAndCountInput!) {
    secretTypesAndCount(args: $args) {
      totalTypes
      typeCounts {
        count
        type
      }
    }
  }
`;
export const QL_SECRET_STATUS_COUNT = gql`
  query secretStatusCount($args: SecretStatusCountInput!) {
    secretStatusCount(args: $args) {
      count
      name
    }
  }
`;
export const GET_SECRET = gql`
  query secret($args: SecretInput!, $includeReachabilityV2: Boolean = false) {
    secret(args: $args) {
      id
      type
      subtype
      severity
      filePath
      description
      category
      categoryLabel
      sanitizedSecret
      rawSecret
      isReachable @include(if: $includeReachabilityV2)
      correlations {
        assetId
        assetName
      }
      correlationsCount
      remediationStatus
      currentRemediation {
        secretId
        status
        description
        author
        createdAt
      }
    }
  }
`;
export const GET_RAW_SECRET = gql`
  query secret($args: SecretInput!) {
    secret(args: $args) {
      id
      rawSecret
    }
  }
`;

export const QL_SECRET_CATEGORIES_SUMMARY = gql`
  query secretCategoriesSummary($args: SecretCategoriesInput!) {
    secretCategoriesSummary(args: $args) {
      category
      categoryLabel
      remediationStatusCounts {
        status
        count
      }
      severityCounts {
        severity
        count
      }
    }
  }
`;

export const QL_SECRETS = gql`
  query secrets($args: SecretsInput!, $includeReachabilityV2: Boolean = false) {
    secrets(args: $args) {
      edges {
        cursor
        node {
          id
          type
          subtype
          severity
          filePath
          description
          category
          categoryLabel
          sanitizedSecret
          rawSecret
          isReachable @include(if: $includeReachabilityV2)
          correlations {
            assetId
            assetName
          }
          correlationsCount
          remediationStatus
          currentRemediation {
            secretId
            status
            description
            author
            createdAt
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
        totalCount
      }
    }
  }
`;

export const REMEDIATE_SECRETS = gql`
  mutation remediateSecrets($args: CreateSecretsRemediationInput!) {
    remediateSecrets(args: $args) {
      secretId
      status
    }
  }
`;

export const GET_SECRET_REACHABILITY = gql`
  query getSecretReachability($args: GetSecretReachabilityInput!) {
    getSecretReachability(args: $args) {
      user
      entryPoint
      entryType
      scripts {
        path
        invocation
        edgeType
        detail
      }
    }
  }
`;
